import React from 'react';
import ReactDOM from 'react-dom';
import {render} from "react-dom";
import App from './App';
import {StateProvider} from '../src/js/context/store.js';
import './index.css';

import * as serviceWorker from './serviceWorker';


import {
    OMNISCAN_BLUE,
    OMNISCAN_BLUE_RGB,
    OMNISCAN_BLUE_SOFT,
    OMNISCAN_BLUE_SOFT_RGB
} from "./js/constants/colors";


//========================================================
// OMNISCAN BRAND COLOURS
// Expose JavaScript constants to CSS
//========================================================

document.documentElement.style.setProperty(
    "--omniscan-blue",
    OMNISCAN_BLUE
);

document.documentElement.style.setProperty(
    "--omniscan-blue-rgb",
    OMNISCAN_BLUE_RGB
);

document.documentElement.style.setProperty(
    "--omniscan-blue-soft",
    OMNISCAN_BLUE_SOFT
);

document.documentElement.style.setProperty(
    "--omniscan-blue-soft-rgb",
    OMNISCAN_BLUE_SOFT_RGB
);



ReactDOM.render(
		
		<StateProvider>
		
		<App/>
		</StateProvider>
	, document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();


